import { Colors } from 'src/common';
import styled from 'styled-components';

type Unit = 'rem' | 'px';

interface DotLoaderProps {
  width?: `${number}${Unit}`;
  height?: `${number}${Unit}`;
  color?: `#${string}` | (typeof Colors)[keyof typeof Colors];
}

export const DotLoader = styled.div<DotLoaderProps>`
  width: ${(props) => props.width ?? '12px'};
  height: ${(props) => props.height ?? '12px'};
  background: ${(props) => props.color ?? Colors.Red50};
  border-radius: 50%;
  box-shadow: 20px 0 #e6000022, -20px 0 ${(props) => props.color ?? Colors.Red50};
  animation: d5 1s infinite linear alternate;
  margin: auto;

  @keyframes d5 {
    0% {
      box-shadow: 20px 0 ${(props) => props.color ?? Colors.Red50}, -20px 0 #e6000022;
      background: ${(props) => props.color ?? Colors.Red50};
    }
    33% {
      box-shadow: 20px 0 ${(props) => props.color ?? Colors.Red50}, -20px 0 #e6000022;
      background: #e6000022;
    }
    66% {
      box-shadow: 20px 0 #e6000022, -20px 0 ${(props) => props.color ?? Colors.Red50};
      background: #e6000022;
    }
  }
`;
